export default "__VITE_ASSET__Bkbml5rg__"